import {
    RichTextExtensionBlockquote,
    RichTextExtensionBold,
    RichTextExtensionBulletList,
    RichTextExtensionCode,
    RichTextExtensionCodeBlock,
    RichTextExtensionDocument,
    RichTextExtensionHardBreak,
    RichTextExtensionHeading,
    RichTextExtensionHistory,
    RichTextExtensionItalic,
    RichTextExtensionListItem,
    RichTextExtensionOrderedList,
    RichTextExtensionParagraph,
    RichTextExtensionStrike,
    RichTextExtensionText
} from "@wix/devzai-utils-react";

export const DoppeActionContentTipTapExtensions = [
    RichTextExtensionBlockquote, RichTextExtensionBold, RichTextExtensionBulletList,
    RichTextExtensionCode, RichTextExtensionCodeBlock, RichTextExtensionDocument, RichTextExtensionHardBreak,
    RichTextExtensionHeading, RichTextExtensionHistory, RichTextExtensionItalic, RichTextExtensionListItem,
    RichTextExtensionOrderedList, RichTextExtensionParagraph, RichTextExtensionStrike, RichTextExtensionText
]
